import "core-js/modules/es6.array.map";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import createLinksTree from './createLinksTree';

function NavigationHeadings(_ref) {
  var headings = _ref.headings;
  var navTree = createLinksTree(headings);
  return React.createElement("div", {
    id: "toc",
    className: "toc-list-h1"
  }, navTree.map(function (link) {
    return React.createElement("li", {
      key: link.to
    }, React.createElement("a", {
      href: link.to,
      className: classNames('toc-link', 'toc-h1')
    }, link.value), link.children && link.children.length > 0 && React.createElement("ul", {
      className: "toc-list-h2"
    }, link.children.map(function (childLink) {
      return React.createElement("li", {
        key: childLink.to
      }, React.createElement("a", {
        href: childLink.to,
        className: classNames('toc-link', childLink.depth < 3 ? 'toc-h2' : 'toc-h3')
      }, childLink.value));
    })));
  }));
}

NavigationHeadings.propTypes = {
  headings: PropTypes.any.isRequired
};
export default NavigationHeadings;